module.exports = __webpack_public_path__ + "img/ep-login.03adcc63.svg";